import { Component, Input } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { GenericCrudAddComponent } from 'src/app/libs/components/generic-crud/generic-crud-add.component';
import { fromSecondsToTimeSpanString, fromTimeSpanStringToSeconds, secondsToHhmmss, subscribeToDurationChanges } from 'src/app/libs/utils';
import { AttendanceEntry, TId } from 'src/app/models';


@Component({
    selector: 'app-attendance-entries-add',
    templateUrl: './attendance-entries-add.component.html',
    styleUrl: './attendance-entries-add.component.sass',
    standalone: false
})
export class AttendanceEntriesAddComponent extends GenericCrudAddComponent<AttendanceEntry> {

  @Input() workerId?: TId;

  override resource = this.api.resources.attendanceEntries;
  workers = this.api.resources.workers;
  attendanceTime: string = '';

  override initFormGroup(): FormGroup {
    const group = this.fb.group({
      workerId: [this.workerId],
      entryIn: [],
      entryOut: [null],
      attendanceTime: ['00:00:00'],

    });

    subscribeToDurationChanges(group, 'entryIn', 'entryOut', 'attendanceTime');
    
    return group;
  }
  
  override onInitExtendActions(): void {
    if (this.form?.get('workerId')?.value) {
      this.form?.get('workerId')?.disable();
    }
  }

  override async mapFormEntity(): Promise<Partial<AttendanceEntry>> {
    this.form?.get('workerId')?.enable();
    const entrie: AttendanceEntry = this.form!.value;
    entrie.companyId = this.api.auth.userValue!.lastCompanyId;
    entrie.attendanceTime = fromTimeSpanStringToSeconds(this.form!.value.attendanceTime);
    return entrie;
  }
}
